declare var htmx: any;

export class Case {
    constructor() {
        $("#advancedSearch").parent()
            .on("click", "#advancedSearch .jResetFilter", this.#resetFilter);
    }

    /** Resets the corresponding filter and triggers the "change" event. */
    #resetFilter = (event: JQuery.ClickEvent) => {
        const filter = event.target.dataset.filter;
        const select = $(`#${filter}`) as JQuery<HTMLSelectElement>;
        (select.get(0) as HTMLSelectElement).selectedIndex = 0;
        //select.trigger("change");
        htmx.trigger(select.get(0), "change");
    }
}
